<template>
  <div v-if="label" class="promotion-label" >
    <span :class="labelClass">{{ label }}</span>
  </div>
</template>

<script>


export default {
  props: {
    promotion: {
      type: Array,
      required: true
    }
  },
  computed: {
    label() {
      if (this.promotion[0].searchKey.toLowerCase() === 'campaign') {
        return this.promotion[0].name
      } else if (this.promotion[0].searchKey.toLowerCase() === 'new') {
        return this.promotion[0].name
      } else if (this.promotion[0].searchKey.toLowerCase() === 'special') {
        return this.promotion[0].name
      }
      return null
    },
    labelClass() {
      return this.promotion[0].searchKey ? this.promotion[0].searchKey.toLowerCase() : ''
    }
  }
}
</script>

<style lang="scss" scoped>

.promotion-label {  
   display: flex;
   align-items: center;
   margin: 0 0 24px;
   
    span { 
      color: white;
      padding: 2px 13px;
      rotate: -5deg;
      font-weight: bold;
      letter-spacing: 2px;

      &.campaign {
            background-color: #ffa500;
            box-shadow: 6px 4px 0px #d27f03;          

            &:after {
                box-shadow: 6px 6px 0px #d27f03;
            }
        }

        &.new {
            box-shadow: 6px 4px 0px #106eb8;
            background-color: #2196F3;              

            &:after {
                box-shadow: 6px 6px 0px #106eb8;
            }
        }

        &.special {
            box-shadow: 6px 4px 0px #258a82;
            background-color: #35c1b6;              

            &:after {
                box-shadow: 6px 6px 0px #258a82;
            }
        }


      &:before,
      &:after {
        background: inherit;
        content: '';
        display: block;
        height: 50%;
        left: 0;
        position: absolute;
        right: 0;
        z-index: -1;
        -webkit-backface-visibility: hidden; // for Chrome Windows
      }

      &:before {
        top: 0;
        transform: skewY(3.5deg);
        transform-origin: 100% 0;
      }

      &:after {
        bottom: 0;
        transform: skewY(-3.5deg);
        transform-origin: 100%;
      }
    }
}
</style>